import { render, staticRenderFns } from "./Masters.vue?vue&type=template&id=0644db53"
import script from "./Masters.vue?vue&type=script&lang=js"
export * from "./Masters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports